var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeclineIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.875 9C0.875 4.51269 4.51269 0.875 9 0.875C13.4873 0.875 17.125 4.51269 17.125 9C17.125 13.4873 13.4873 17.125 9 17.125C4.51269 17.125 0.875 13.4873 0.875 9ZM8.1302 7.79871C9.0854 7.32111 10.1609 8.18386 9.9019 9.21991L9.31105 11.5833L9.34563 11.566C9.65436 11.4116 10.0298 11.5368 10.1842 11.8455C10.3385 12.1542 10.2134 12.5297 9.90465 12.684L9.87007 12.7013C8.91488 13.1789 7.83936 12.3162 8.09838 11.2801L8.68922 8.91674L8.65465 8.93403C8.34591 9.0884 7.97049 8.96326 7.81612 8.65452C7.66175 8.34578 7.78689 7.97036 8.09563 7.81599L8.1302 7.79871ZM9 6.5C9.34518 6.5 9.625 6.22018 9.625 5.875C9.625 5.52982 9.34518 5.25 9 5.25C8.65482 5.25 8.375 5.52982 8.375 5.875C8.375 6.22018 8.65482 6.5 9 6.5Z",
    fill: "#B42318"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclineIcon);
export default __webpack_public_path__ + "static/media/declineIcon.65b0312240949f3a18df2a5ea54ab3d8.svg";
export { ForwardRef as ReactComponent };